import { createApp } from 'vue'
import { createPinia } from 'pinia'

import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'

import App from './App.vue'
import router from './router'

import '@/assets/styles.scss'

// Aura con il teal come colore primario: l'unico tema del pannello
const KrisAgentTheme = definePreset(Aura, {
  semantic: {
    primary: Object.fromEntries([50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950].map((shade) => [shade, `{teal.${shade}}`])),
  },
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(PrimeVue, {
  theme: {
    preset: KrisAgentTheme,
    options: {
      // Solo tema chiaro: nessuno aggiunge mai .app-dark, quindi il prefers-color-scheme del sistema non conta
      darkModeSelector: '.app-dark',
    },
  },
})
app.use(ToastService)
app.use(ConfirmationService)

app.mount('#app')
